import { useAppsByAppKeyPolling } from '@/api/queries/useAppsByAppKey';
import { MediaAssetProviders } from '@/features/ai-video-creator/stores/productMediaSlice';
import { useCurrentApp } from '@/stores/userDataStore';
const useProviderConnectionStatus = () => {
  const { appKey, appUrl, isLoading: isUserLoading } = useCurrentApp();

  const { data: apps, isLoading: isAppsLoading } = useAppsByAppKeyPolling(appKey);

  const activeApps = apps?.filter((app) => (app.appUrl === appUrl || app.appUrl === null) && app.active);

  const connectionStatusByProvider = Object.fromEntries(
    Object.entries(MediaAssetProviders).map(([, value]) => [value, !!activeApps?.some((app) => app.app === value)])
  );

  const appsByProvider = Object.fromEntries(
    Object.values(MediaAssetProviders).map((provider) => [
      provider,
      activeApps?.filter((app) => app.app === provider) || [],
    ])
  );

  return {
    connectionStatusByProvider,
    isLoading: isAppsLoading || isUserLoading,
    appsByProvider,
  };
};

export default useProviderConnectionStatus;
